<template>
  <v-card class elevation="0">
    <v-card-text>
      <p class="display-1 text--primary">Change Password</p>
      <p>Provide a safe password for your Ikano AWS user</p>
      <v-card
        elevation="3"
        class="mx-auto mt-6 px-3 pb-3"
        :disabled="this.$store.state.didSetPassword"
      >
        <v-form ref="form" v-model="valid">
          <v-text-field
            :type="show2 ? 'text' : 'password'"
            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="show2 = !show2"
            v-model="newPass"
            :rules="passwordRules"
            :disabled="this.$store.state.didSetPassword"
            label="New Password"
            required
          ></v-text-field>
          <v-text-field
            :type="show1 ? 'text' : 'password'"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="show1 = !show1"
            v-model="newPassRepeat"
            :rules="repeatPasswordRules"
            :disabled="this.$store.state.didSetPassword"
            label="Confirm Password"
            required
          ></v-text-field>
          <v-btn
            v-if="!this.$store.state.didSetPassword"
            width="100%"
            class="px-5"
            color="primary"
            @click="changePassword"
            :loading="changingPassword"
          >Change Password</v-btn>
          <v-btn
            v-else
            :disabled="true"
            width="100%"
            class="px-5"
            color="secondary"
          >Successfully changed</v-btn>
        </v-form>
      </v-card>
      <br />
      <br />
      <div class="text--primary">
        <b>Password Complexity:</b>
        <ul>
          <li>Password must be 10 or more characters long</li>
          <li>No spaces are allowed</li>
          <li>Must have one uppercase character</li>
          <li>Must have atleast one number</li>
          <li>Must have atleast one special character</li>
          <li>Must not include your username(BAF id)</li>
        </ul>
        <br />
        <b>Password Protection:</b>
        <ul>
          <li>
            Passwords must not be shared with anyone, including administrative
            assistants, secretaries, managers, co-workers while on vacation, and
            family members. All passwords are to be treated as sensitive and
            strictly confidential information.
          </li>
          <li>
            Passwords must not be inserted into email messages or other forms of
            electronic communication
          </li>
          <li>Passwords must not be revealed over the phone to anyone</li>
          <li>
            Passwords must not be revealed on questionnaires or security forms
          </li>
          <li>Passwords must not be hinted out</li>
          <li>Passwords must not be written down</li>
          <li>
            Passwords may not be stored in files locally on computers, servers,
            systems or mobile devices without being salted and encrypted through
            strong encryption
          </li>
          <li>
            Passwords may not be transmitted in clear text over the network, it
            must be protected using strong encryption
          </li>
          <li>
            Any user suspecting their password has been compromised must report
            the incident and change the password everywhere it is used
          </li>
        </ul>
        <br />
      </div>
      <br />
    </v-card-text>
  </v-card>
</template>

<script>
import Authentication from "../../auth";
import EventBus from "../../utility/Eventbus";
export default {
  name: "ChangePassword",
  data() {
    return {
      success: false,
      changingPassword: false,
      valid: true,
      show1: false,
      show2: false,
      passwordRules: [
        v => !!v || "Please provide a new password",
        v =>
          (v && v.length >= 10) ||
          "Password must be 10 or more characters long",
        v => (v || "").indexOf(" ") < 0 || "No spaces are allowed",
        v => /(?=.*[A-Z])/.test(v) || "Must have one uppercase character",
        v => /(?=.*\d)/.test(v) || "Must have one number",
        v => /([!@#$%^&*"])/.test(v) || "Must have one special character"
      ],
      repeatPasswordRules: [
        v => !!v || "Please confirm password",
        v => (!!v && v == this.newPass) || "Passwords do not match"
      ],
      name: "",
      newPass: "",
      newPassRepeat: ""
    };
  },
  methods: {
    async changePassword() {
      this.validate();
      if (this.valid) {
        this.changingPassword = true;

        const response = await Authentication.fetch(
          "api/activedir/changepassword",
          "POST",
          {
            newPassword: this.newPass
          }
        );
        if (response && response.message) {
          EventBus.$emit("snackbar", response.message);
          this.$store.commit("setDidChangePassword", true);
          this.$refs.form.reset();
        }

        // GJD!4545dfds12467

        this.$store.commit("setDidChangePassword", true);

        this.$emit("validPassword", true);
        this.changingPassword = false;
      }
    },
    async isNewUser() {
      const flags = await this.$store.dispatch("flags");
      return flags.FORCE_RESET_PASSWORD;
    },
    validate() {
      this.$refs.form.validate();
    },
    goTo(path) {
      this.$route.path !== path && this.$router.go(path);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
